import type { ReactNode } from "react";
import { Box } from "@hightouch/htui";

type CardsGridProps = { children: ReactNode };

export const CardsGrid = ({ children }: CardsGridProps) => (
  <Box
    display="grid"
    gridTemplateColumns="repeat(auto-fill, minmax(var(--chakra-sizes-44), 1fr))"
    gap={3}
  >
    {children}
  </Box>
);
